import { observer } from "mobx-react-lite";
import { Info } from "lucide-react";

import { Input } from "@/components/ui/input";

interface VariableProps {
  variableName: string | undefined;
  onNameChange: (name: string) => void;
  isReadonly?: boolean;
  errors?: Record<string, string>;
}

const Variable = observer(
  ({ variableName, onNameChange, isReadonly = false, errors }: VariableProps) => {
    const hasVariableNameError = errors && errors.variableName;

    return (
      <div className="mb-4 ml-6 max-w-[500px] rounded-md border border-gray-200 bg-white p-4 shadow-sm">
        <div className="mb-2 text-sm font-medium text-gray-700">
          Variable name (inject schema at runtime):
        </div>
        <div className="relative">
          <span className="absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-gray-400">
            {"{{"}
          </span>
          <Input
            type="text"
            value={variableName || ""}
            onChange={e => onNameChange(e.target.value)}
            placeholder="schemaVariableName"
            className={`pl-8 pr-8 font-mono ${hasVariableNameError ? "border-red-500" : ""}`}
            readOnly={isReadonly}
          />
          <span className="absolute right-3 top-1/2 z-10 -translate-y-1/2 text-sm text-gray-400">
            {"}}"}
          </span>
        </div>
        {hasVariableNameError && (
          <div className="mt-1 text-xs text-red-500">{errors!.variableName}</div>
        )}
        <div className="mt-3 flex items-start gap-2 rounded-md bg-blue-50 p-3 text-xs text-blue-700">
          <Info className="mt-0.5 h-4 w-4 flex-shrink-0" />
          <div className="space-y-1">
            <div className="font-medium">How variable schemas work:</div>
            <ul className="list-inside list-disc space-y-1">
              <li>
                This entire field will be replaced with a complete JSON schema object at runtime
              </li>
              <li>Pass the schema as an input variable using the name above</li>
              <li>The injected schema will have its own properties and structure</li>
            </ul>
          </div>
        </div>
      </div>
    );
  },
);

export default Variable;
